import { render, staticRenderFns } from "./pageContactMsg.vue?vue&type=template&id=34de1e4f&scoped=true"
import script from "./pageContactMsg.vue?vue&type=script&lang=js"
export * from "./pageContactMsg.vue?vue&type=script&lang=js"
import style0 from "./pageContactMsg.vue?vue&type=style&index=0&id=34de1e4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34de1e4f",
  null
  
)

export default component.exports